import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

//图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

//懒加载
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/api'

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'zIndex':99999,'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': false, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source'}
  //关闭播放按钮
  // 'toolbar': false
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const type = to.meta.type
  // 判断该路由是否需要登录权限
  if (type === 'login') {
    // console.log(window.localStorage.getItem('token'))
    var token = window.localStorage.getItem('token');
    if (token) {
      axios.post(
        store.state.domain+'/check_login', { token:token }
      ).then(function (res) {
        var data = res.data;
        if (data.code == '200ok') {
          next()
        }  else {
          next('/login')
        }
      }).catch(function (error) {
        next('/login')
      })
    } else {
      next('/login')
    }
  } else {
    next() // 确保一定要有next()被调用
  }
})

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({

  router,
  store,

  render: h => h(App)
}).$mount('#app')